export default __webpack_public_path__ + "static/media/4S.7e474260.svg";